export const SET_ACTIVE_CATEGORY  = (state, message) => {
	state.currentCategory = message;
}

export const SET_ACTIVE_GAME = (state, message) => {
	state.currentGame = message;
}


// WEBPACK FOOTER //
// ./src/store/mutations.js